import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/node';

import {TenantResponseBody, GetBranchListApiResponse, GetBranchApiResponse} from '@dms/api/shared';

// TODO: FIX in T20-56846
// eslint-disable-next-line no-restricted-syntax
const getTenantResponseMock = {
  id: 'f2e781c7-16e7-4140-9649-5424bc4fbf4a',
  country: 'CZE',
  currency: 'CZK',
  type: 'selfEmployed',
  publicContacts: {
    phoneNumber: {
      countryCode: 'CZE',
      prefix: '+420',
      number: '325346765',
    },
    emailAddress: null,
    website: 'www.testovaci.do',
  },
  contactInformation: {
    registrationNumber: '48906565',
    vatNumber: 'CZ48906565',
    companyName: 'TEAS spol. s r.o.',
    address: {
      street: 'Platnéřská 88/9',
      city: 'Praha 8',
      zipCode: '11000',
      country: 'CZE',
      state: null,
    },
    selfEmployedInformation: {
      firstName: 'Jmeno',
      lastName: 'Prijmeni',
      titleBefore: null,
      titleAfter: null,
      phoneNumber: {
        countryCode: 'CZE',
        prefix: '+420',
        number: '232111333',
      },
      emailAddress: null,
    },
    fileNumber: 'C 336897, Městský soud v Praze',
  },
  contactPersons: [
    {
      firstName: 'Jenda',
      lastName: 'Benda',
      role: 'Boss',
      phoneNumber: {
        countryCode: 'CZE',
        prefix: '',
        number: '',
      },
      emailAddress: 'boss@benda.com',
      isPrimary: false,
    },
    {
      firstName: null,
      lastName: null,
      role: null,
      phoneNumber: {
        countryCode: 'CZE',
        prefix: '',
        number: '',
      },
      emailAddress: null,
      isPrimary: true,
    },
  ],
  billingInformation: [
    {
      id: '2d191d67-e985-40e4-9b66-1d327f7a4074',
      isPrimary: false,
      billingName: 'TEAS spol. s r.o.',
      contactInformation: {
        registrationNumber: '48906565',
        vatNumber: 'CZ48906565',
        companyName: 'TEAS spol. s r.o.',
        address: {
          street: 'Platnéřská 88/9',
          city: 'Praha 1',
          zipCode: '11000',
          country: 'CZE',
          state: null,
        },
        selfEmployedInformation: null,
        fileNumber: 'C 336897, Městský soud v Praze',
      },
      bankAccounts: [
        {
          bankName: 'Komerční banka',
          isPrimary: true,
          accountName: 'Primár',
          accountNumber: '123456796/0100',
          currency: 'CZK',
          swift: null,
          iban: null,
        },
        {
          bankName: 'Komercni banka',
          isPrimary: false,
          accountName: 'Tetso',
          accountNumber: '16767767/0100',
          currency: 'CZK',
          swift: null,
          iban: null,
        },
      ],
      deputyPersons: [
        {
          isPrimary: false,
          firstName: null,
          lastName: null,
          dateOfBirth: null,
          personalIdType: null,
          personalIdNumber: null,
          validUntil: null,
          issuedBy: null,
          identificationNumber: null,
        },
        {
          isPrimary: false,
          firstName: null,
          lastName: null,
          dateOfBirth: null,
          personalIdType: null,
          personalIdNumber: null,
          validUntil: null,
          issuedBy: null,
          identificationNumber: null,
        },
      ],
    },
    {
      id: '7aafd041-f024-4550-876a-7b1bab2ff50c',
      isPrimary: false,
      billingName: 'TEST RRR',
      contactInformation: {
        registrationNumber: '26600889',
        vatNumber: 'CZ26600889',
        companyName: 'Test RTT1',
        address: {
          street: 'Platnéřská 90/13',
          city: 'Praha',
          zipCode: '11000',
          country: 'CZE',
          state: '',
        },
        selfEmployedInformation: null,
        fileNumber: 'L 12956 vedená u Městského soudu v Praze',
      },
      bankAccounts: [
        {
          bankName: 'CSOB',
          isPrimary: false,
          accountName: 'CSOB EURO',
          accountNumber: '670100-2211504021/6210',
          currency: 'EUR',
          swift: 'BREXCZPP',
          iban: 'CZ7462106701002211504021',
        },
        {
          bankName: 'KB',
          isPrimary: false,
          accountName: 'JKJKJJK',
          accountNumber: '115-3058630287/0100',
          currency: 'CZK',
          swift: null,
          iban: null,
        },
      ],
      deputyPersons: [],
    },
  ],
} as unknown as TenantResponseBody;

const getTenantResponseInterceptor = (server: SetupServerApi) =>
  server.use(http.get('*/dms/v1/tenant', () => HttpResponse.json(getTenantResponseMock)));

const getBranchListResponseMock: GetBranchListApiResponse = {
  branchListItems: [
    {
      id: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
      marketingName: '(Czech) Praha',
      companyName: 'TEAS spol. s r.o.',
      city: 'Praha 1',
      street: 'Platnéřská 88/9',
      usersCount: 156,
    },
    {
      id: 'f7a95bdb-af70-4431-91fb-edbe45ff984e',
      marketingName: 'Home service',
      companyName: 'TEAS spol. s r.o.',
      city: 'home',
      street: 'home',
      usersCount: 0,
    },
    {
      id: '1f3d02fd-99dc-462f-9c12-9c5dd631cfa5',
      marketingName: 'Hyundai Czech',
      companyName: 'TEAS spol. s r.o.',
      city: 'Praha',
      street: 'Hyundai Czech',
      usersCount: 24,
    },
    {
      id: '8f8d33b3-9464-484e-829a-fa621d442106',
      marketingName: 'Hyundai Maciej Test',
      companyName: 'Test RTT1',
      city: 'Katowice',
      street: 'Testowa',
      usersCount: 1,
    },
    {
      id: '73c0c39c-8ad1-44f9-a3c9-6cb193c6aba1',
      marketingName: 'Hyundai Slovakia',
      companyName: 'TEAS spol. s r.o.',
      city: 'Bratislava',
      street: 'Hyundai Slovakia',
      usersCount: 16,
    },
    {
      id: '3afda71f-0535-4333-aa65-bd68fd584bf7',
      marketingName: 'Jan Vrábel',
      companyName: 'TEAS spol. s r.o.',
      city: 'Mělník',
      street: 'Na Výsluní 4207',
      usersCount: 18,
    },
    {
      id: 'e0e303be-87ec-4bbd-96a2-7e50a6bc0ffb',
      marketingName: 'JHJHJ',
      companyName: 'Test RTT1',
      city: 'Praha',
      street: 'LLL 22',
      usersCount: 32,
    },
    {
      id: '4865e2a6-664a-467a-91f8-24d58d2d7c6e',
      marketingName: '(Poland) Warsaw',
      companyName: 'TEAS spol. s r.o.',
      city: 'Warszawa',
      street: 'Wiejska',
      usersCount: 23,
    },
    {
      id: '29eaa1fc-3e1c-4a40-8b57-ec46e1bcdb22',
      marketingName: '(Slovakia) Bratislava',
      companyName: 'TEAS spol. s r.o.',
      city: 'Praha',
      street: 'Náchodská 20',
      usersCount: 98,
    },
    {
      id: 'f01fce3d-db81-4323-94d8-383991101ca2',
      marketingName: 'string',
      companyName: 'TEAS spol. s r.o.',
      city: 'string',
      street: 'string',
      usersCount: 28,
    },
    {
      id: '259d9832-d79f-4102-abb7-a8fc43b21519',
      marketingName: 'test',
      companyName: 'TEAS spol. s r.o.',
      city: 'Teplice 1',
      street: 'J. V. Sládka',
      usersCount: 11,
    },
  ],
};

const getBranchListResponseInterceptor = (server: SetupServerApi) =>
  server.use(
    http.get('*/dms/v1/tenant/branch', () => HttpResponse.json(getBranchListResponseMock))
  );

const getBranchResponseMock: GetBranchApiResponse = {
  id: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
  tenantId: 'f2e781c7-16e7-4140-9649-5424bc4fbf4a',
  name: '(Czech) Praha',
  code: '',
  registrationNumber: '48906565',
  vatNumber: 'CZ48906565',
  companyName: 'TEAS spol. s r.o.',
  fileNumber: 'C 336897, Městský soud v Praze',
  address: {
    street: 'Platnéřská 88/9',
    city: 'Praha 1',
    zipCode: '11000',
    country: 'CZE',
    state: null,
  },
  publicContacts: {
    phoneNumber: {
      countryCode: 'CZE',
      prefix: '+420',
      number: '77766655',
    },
    emailAddress: 'info@teas.cz',
    website: 'www.teas.cz',
  },
  billingInformation: {
    id: '2d191d67-e985-40e4-9b66-1d327f7a4074',
    isPrimary: false,
    billingName: 'TEAS spol. s r.o.',
    contactInformation: {
      registrationNumber: '48906565',
      vatNumber: 'CZ48906565',
      companyName: 'TEAS spol. s r.o.',
      address: {
        street: 'Platnéřská 88/9',
        city: 'Praha 1',
        zipCode: '11000',
        country: 'CZE',
        state: null,
      },
      selfEmployedInformation: null,
      fileNumber: 'C 336897, Městský soud v Praze',
    },
    bankAccounts: [
      {
        bankName: 'Komerční banka',
        isPrimary: true,
        accountName: 'Primár',
        accountNumber: '123456796/0100',
        currency: 'CZK',
        swift: null,
        iban: null,
      },
      {
        bankName: 'Komercni banka',
        isPrimary: false,
        accountName: 'Tetso',
        accountNumber: '16767767/0100',
        currency: 'CZK',
        swift: null,
        iban: null,
      },
    ],
    deputyPersons: [],
  },
  contactPersons: [
    {
      firstName: null,
      lastName: null,
      role: null,
      phoneNumber: {
        countryCode: 'CZE',
        prefix: '',
        number: '',
      },
      emailAddress: null,
      isPrimary: true,
    },
    {
      firstName: null,
      lastName: null,
      role: null,
      phoneNumber: {
        countryCode: 'CZE',
        prefix: '',
        number: '',
      },
      emailAddress: null,
      isPrimary: false,
    },
  ],
  accountingExternalId: null,
};

const getBranchResponseInterceptor = (server: SetupServerApi) =>
  server.use(http.get('*/dms/v1/tenant/branch/*', () => HttpResponse.json(getBranchResponseMock)));

export const tenantApiMock = {
  getTenantResponseMock,
  getTenantResponseInterceptor,
  getBranchListResponseMock,
  getBranchListResponseInterceptor,
  getBranchResponseInterceptor,
};
